import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ENDPOINT from '../../data/ENDPOINT';
import axios from 'axios';

const BatchSelection = () => {
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBatches = async () => {
      try {
        const response = await axios.get(`${ENDPOINT}get-hacking-internship-batch.php`);
        
        if (response.data.status === 'success') {
          // Sort batches by start_date (optional)
          const sortedBatches = response.data.data.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
          setBatches(sortedBatches);
        } else {
          setError(response.data.message || 'Failed to load batches');
        }
      } catch (err) {
        setError('Network error. Please try again later.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchBatches();
  }, []);

  // Helper: Format date to "15th May"
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const suffix = ['th', 'st', 'nd', 'rd'][(day % 10 > 3 ? 0 : day % 10)] || 'th';
    return `${day}${suffix} ${month}`;
  };

  // Determine which batch is "featured" (e.g., earliest upcoming)
  const getFeaturedIndex = () => {
    const now = new Date();
    const upcoming = batches.filter(b => new Date(b.start_date) >= now);
    return upcoming.length > 0 ? batches.indexOf(upcoming[0]) : -1;
  };

  const featuredIndex = getFeaturedIndex();

  // CSS (same as original design)
  const styles = `
    .batch-selection-section {
      background-color: #f0f2f5;
      font-family: sans-serif;
      padding: 5rem 0;
    }

    .batch-card {
      border: 1px solid #e9ecef;
      border-radius: 0.75rem;
      box-shadow: 0 4px 25px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .batch-card:hover {
      transform: translateY(-10px);
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
    }
    
    .batch-card .card-header {
      background-color: transparent;
      border-bottom: 1px solid #e9ecef;
      padding: 1rem;
      font-size: 1.5rem;
      font-weight: 600;
      text-align: center;
    }
    
    .batch-card .card-body {
      padding: 1rem;
      text-align: center;
      flex-grow: 1;
    }

    .batch-card .date-info {
        font-size: 1.1rem;
        color: #6c757d;
        margin-bottom: 0.5rem;
    }

    .batch-card .btn-register {
      width: 100%;
      padding: 0.75rem;
      font-size: 1rem;
      font-weight: 500;
      border-radius: 0.5rem;
    }
    
    .batch-card.featured {
      border-color: #0d6efd;
      transform: scale(1.05);
      position: relative;
      overflow: hidden;
      z-index: 1;
    }
    
    .featured-badge {
      position: absolute;
      top: 15px;
      right: -35px;
      background-color: #0d6efd;
      color: white;
      padding: 5px 40px;
      transform: rotate(45deg);
      font-size: 0.8rem;
      font-weight: bold;
      z-index: 2;
    }

    .slot-status {
      font-size: 0.95rem;
      padding: 4px 10px;
      border-radius: 50px;
      margin: 4px;
      display: inline-block;
    }

    .slot-morning { background: #fff3cd; color: #856404; }
    .slot-afternoon { background: #d1ecf1; color: #0c5460; }
    .slot-evening { background: #d4edda; color: #155724; }
  `;

  return (
    <>
      <style>{styles}</style>
      <div className="batch-selection-section">
        <Container>
          {loading ? (
            <Alert variant="info" className="text-center">Loading batches...</Alert>
          ) : error ? (
            <Alert variant="danger" className="text-center">{error}</Alert>
          ) : batches.length === 0 ? (
            <Alert variant="warning" className="text-center">No batches available at the moment.</Alert>
          ) : (
            <Row className="justify-content-center align-items-stretch g-4">
              {batches.map((batch, index) => {
                const isFeatured = index === featuredIndex;
                const startDate = formatDate(batch.start_date);
                const regEndDate = formatDate(batch.end_date);

                return (
                  <Col key={batch.internship_id} md={6} lg={4}>
                    <Card className={`batch-card ${isFeatured ? 'featured' : ''}`}>
                      {isFeatured && <div className="featured-badge">RECOMMENDED</div>}
                      <Card.Header>{batch.batch_name}</Card.Header>
                      <Card.Body>
                        <p className="date-info">Starts: {startDate}</p>
                        <p className="date-info fw-bold">Registration Ends: {regEndDate}</p>

                        {/* Slot Availability */}
                        {/* <div className="mt-3">
                          <small className="text-muted d-block mb-2">Available Slots:</small>
                          <span className={`slot-status slot-morning`}>{batch.morning_slot}</span>
                          <span className={`slot-status slot-afternoon`}>{batch.afternoon_slot}</span>
                          <span className={`slot-status slot-evening`}>{batch.evening_slot}</span>
                        </div> */}
                      </Card.Body>
                      <div className="p-4 pt-0">
                        <Link to="/course/ethical-hacking-specialization/specialization">
                          <Button
                            variant={isFeatured ? 'primary' : 'outline-primary'}
                            className="btn-register"
                          >
                            <HowToRegIcon sx={{ marginRight: '8px', fontSize: '1.2rem' }} />
                            Register Now
                          </Button>
                        </Link>
                      </div>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          )}
        </Container>
      </div>
    </>
  );
};

export default BatchSelection;